export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function upperCase(text) {
    return _.isString(text) ? text.toUpperCase() : text;
}
/**
 * Gets the date in  MMMM D, YYYY format
 *
 * @param {string} date
 * @example => 2017-09-22 --> September 22, 2017
 * @returns {string}
 */
export function humanizeDate(date) {
    if (moment(date).isValid()) {
        return moment(date).format('MMMM D, YYYY');
    }
    return date;
}

/**
 * Gets the date in  MMM D, YYYY format
 *
 * @param {string} date
 * @example => 2017-09-22 --> Sep 22, 2017
 * @returns {string}
 */
export function shortHumanizeDate(date) {
    if (moment(date).isValid()) {
        return moment(date).format('MMM D, YYYY');
    }
    return date;
}
/**
 * Replaces a char for other given char
 * @param {string} text
 * @param {string} char
 * @param {string} replacement
 */
export function replace(text, char, replacement) {
    const regex = new RegExp(char, "g");
    return text.replace(regex, replacement);
}
// Gets the date in relative date format
// @example => 15 minutes ago, 2 years ago, 1 month ago
export function relativeDate(date) {
    if (moment(date).isValid()) {
        return  moment(date).fromNow();
    }
    return date;
}

export function formatMoney(value, decimals = 2) {
    return window.accounting.formatMoney(value, "$", decimals);
}

export function stripTags(html) {
    return $("<div>").html(html).text();
}

export function truncate(text, length = 200, etc = "…", breakWords = false, remaining = false) {
    let truncatedText = "";

    if (!length) {
        return truncatedText;
    }

    if (etc == "...") {
        etc = "…";
    }

    if (text.length > length) {
        if (!breakWords) {
            truncatedText = text.substr(0, length).replace(/\s+?(\S+)?$/, "") + etc;
        } else {
            truncatedText = text.substr(0, length).replace(/\s*$/, "") + etc;
        }
    } else {
        truncatedText = text;
    }

    if (remaining) {
        truncatedText = [truncatedText, text.substr(truncatedText.length - etc.length)];
    }

    return truncatedText;
}
